import {useUnifyAdminStore} from '../../AdminStore';
import { CampaignLinkTextInputWithHelperText } from '../Blocks/CampaignLinkTextInputWithHelperText';
import get from 'lodash/get';
import { t } from 'i18next';

export const CampaignLinkTextFrCAField = (): JSX.Element => {
    /**
     * Data Store
     */
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);
    const updateCreateCampaignData = useUnifyAdminStore((state) => state.updateCreateCampaignData);
    const permissions = useUnifyAdminStore(state => state.permissions); 
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);

    const linkText = get(campaignItems, 'linkText');

    const handleUpdateLinkTextField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateCreateCampaignData({
            fieldName: "linkText",
            value: {enUS: linkText?.enUS, enCA:linkText?.enCA, frCA: event.target.value},
        });
    };

    return (
        <>
            <CampaignLinkTextInputWithHelperText
                dataTestId="campaign-link-text-frca-input"
                id="campaign-link-text-abbr-frca-input"
                inputDivider="left"
                label={t('campaigns.learnMoreLabel')}
                name="linkText"
                onChange={handleUpdateLinkTextField}
                placeholder={t('campaigns.learnMoreFrCAPlaceholder')}
                value={campaignItems.linkText?.frCA}
                isDisabled={archiveSwitch || (campaignItems.id
                    && (!permissions?.hasCampaignUpdatePermissions && !permissions?.hasCampaignSuperAdminPermissions))}
            />
        </>
    );
};
